export default __webpack_public_path__ + "static/media/sponsor-icon-active.00063cfe.webp";